export function fontSize(t, size) {
  return mapSize(size, t.tabFontSizeSmall, t.tabFontSizeMedium, t.tabFontSizeLarge);
}
export function lineHeight(t, size) {
  return mapSize(size, t.tabLineHeightSmall, t.tabLineHeightMedium, t.tabLineHeightLarge);
}
export function paddingX(t, size) {
  return mapSize(size, t.tabPaddingXSmall, t.tabPaddingXMedium, t.tabPaddingXLarge);
}
export function paddingY(t, size) {
  return mapSize(size, t.tabPaddingYSmall, t.tabPaddingYMedium, t.tabPaddingYLarge);
}

function mapSize(size, small, medium, large) {
  switch (size) {
    case 'small':
      return small;

    case 'medium':
      return medium;

    case 'large':
      return large;

    default:
      return small;
  }
}